import { useTranslation } from 'react-i18next';
import RegistrationPhoneForm from '@/components/features/Auth/RegistrationPhoneForm';
import RegistrationBox from '@/components/features/Auth/RegistrationBox';

export default function Register() {
  const { t } = useTranslation(['registration']);

  return (
    <RegistrationBox
      img={'/images/logos/hero-logo-small.svg'}
      title={t('registration:welcome')}
      desc={t('registration:welcomeDesc')}>
      <RegistrationPhoneForm />
    </RegistrationBox>
  );
}
